// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"e91ce440","555":"d824fac2"}[chunkId] + ".chunk.css";
};